<template>
  <v-tabs background-color="transparent">
    <template v-for="item in pages">
      <v-tab
        v-if="item.visible()"
        :key="item.name"
        :to="{ name: item.name, params: { id: yacht.id }}"
        exact
        class="text-none font-weight-regular"
      >
        {{ item.title }}
      </v-tab>
    </template>
  </v-tabs>
</template>
<script>
  export default {
    name: 'Navigation',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        pages: [
          { title: 'Dashboard', name: this.$route.name.includes('service') ? 'serviceYachtDashboard' : 'yachtDashboard', visible: () => this.$can('view', 'Yacht') },
          { title: 'Configuration', name: this.$route.name.includes('service') ? 'serviceYachtConfiguration' : 'yachtConfiguration', visible: () => this.$can('view', 'Yacht') },
          { title: 'Specs', name: this.$route.name.includes('service') ? 'serviceYachtSpecs' : 'yachtSpecs', visible: () => this.$can('view', 'Yacht') },
          { title: 'Logistics', name: this.$route.name.includes('service') ? 'serviceYachtDelivery' : 'yachtDelivery', visible: () => this.$can('set-logistics-plan', 'Yacht') },
          { title: 'Documentation Logistics', name: this.$route.name.includes('service') ? 'serviceYachtLogisticsChecklist' : 'yachtLogisticsChecklist', visible: () => this.$can('set-logistics-plan', 'Yacht') },
          { title: 'Booking', name: this.$route.name.includes('service') ? 'serviceYachtBooking' : 'yachtBooking', visible: () => this.$can('view-booking', 'Yacht') },
          // { title: 'Finance', name: 'yachtFinance', visible: () => this.$can('view-finance', 'Yacht') },
          { title: 'Documents', name: this.$route.name.includes('service') ? 'serviceYachtDocuments' : 'yachtDocuments', visible: () => this.$can('view-documents', 'Yacht') },
          // { title: 'History', name: 'yachtHistory', visible: () => this.$can('view-audits', 'Yacht') },
          { title: 'Comments', name: this.$route.name.includes('service') ? 'serviceYachtComments' : 'yachtComments', visible: () => this.$can('view-comments', 'Yacht') },
          { title: 'Photos', name: this.$route.name.includes('service') ? 'serviceYachtPhotos' : 'yachtPhotos', visible: () => this.$can('view', 'Yacht') }
        ]
      }
    }
  }
</script>
